import React from 'react';
import { ComponentErrorBoundary } from '@app/utilities';
import { useCreateClosureReasons, useRefreshClosureReasons, useUpdateClosureReasons } from '@app/sdk';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer, Input, InputProps } from '@app/shared';
import { ClosureReasonModel } from '@app/models';

export function ClosureReasonForm({ closureReason }: { closureReason: ClosureReasonModel }) {
  const { mutateAsync: update, isPending: isUpdating } = useUpdateClosureReasons();
  const { mutateAsync: create, isPending: isCreating } = useCreateClosureReasons();
  const refreshclosureReasons = useRefreshClosureReasons();
  const isSubmitting = () => isUpdating || isCreating;

  async function onSaveReason(data: ClosureReasonModel) {
    if (closureReason?.id) {
      await update({ request: [{ ...data, id: closureReason.id }] });
    } else {
      await create([data]);
    }

    refreshclosureReasons();
  }

  const formContext = useForm<ClosureReasonModel>();

  const id: InputProps<ClosureReasonModel> = {
    name: 'reason',
    label: 'Reason',
    defaultValue: closureReason?.reason,
  };

  const reason: InputProps<ClosureReasonModel> = {
    name: 'reason',
    label: 'Reason',
    defaultValue: closureReason?.reason,
  };

  const description: InputProps<ClosureReasonModel> = {
    name: 'description',
    label: 'Description',
    defaultValue: closureReason?.description,
  };

  const type: InputProps<ClosureReasonModel> = {
    name: 'type',
    label: 'Type',
    defaultValue: closureReason?.type,
  };

  return (
    <ComponentErrorBoundary>
      <FormProvider {...formContext}>
        <FormContainer isSubmitting={isSubmitting()} onSubmit={onSaveReason} disableButtons>
          <Input {...reason} disabled />
          <Input {...description} disabled />
          <Input {...type} disabled />
        </FormContainer>
      </FormProvider>
    </ComponentErrorBoundary>
  );
}
